var _style, _path, _polygon, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferGoods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.5,14.5c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.7s0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3 s0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7s-0.1-0.5-0.3-0.7C19.1,14.6,18.8,14.5,18.5,14.5z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.5,8.5 17.5,11.5 21.8,11.5 19.5,8.5 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.5,5h2v4.6c0.4,0.1,0.7,0.2,1.1,0.3V5h2v6c0.8,0.7,1.5,1.5,2,2.5h3.1v-9h-12v5.6c0.6-0.3,1.3-0.5,2-0.6V5z  M11.6,5h2v7h-2V5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,5v4.9c0.7,0.2,1.4,0.6,2,1.1V5H8.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.6,
    y: 5,
    className: "st1",
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,9.6V5h-2v4.6c0.3,0,0.5-0.1,0.8-0.1C6.7,9.5,7.1,9.6,7.5,9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.5,6.5h-3v-4h-14c-0.5,0-1,0.2-1.4,0.6S1.5,3.9,1.5,4.5v7.1c0.6-0.6,1.2-1.1,2-1.4V4.5h12v9h-3.1 c0.3,0.6,0.5,1.3,0.5,2h2.5c0,0.8,0.3,1.5,0.9,2.1s1.3,0.9,2.1,0.9s1.5-0.3,2.1-0.9s0.9-1.3,0.9-2.1h2v-5L20.5,6.5z M19.3,16.2 c-0.2,0.2-0.4,0.3-0.7,0.3s-0.5-0.1-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.7s0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3s0.5,0.1,0.7,0.3 c0.2,0.2,0.3,0.4,0.3,0.7S19.5,16,19.3,16.2z M17.5,11.5v-3h2l2.2,3H17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.3,10.5c-3.3,0-5.9,2.7-5.9,5.9c0,3.3,2.7,5.9,5.9,5.9c3.3,0,5.9-2.7,5.9-5.9C12.3,13.2,9.6,10.5,6.3,10.5z  M6.3,21c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c2.5,0,4.5,2,4.5,4.5C10.9,19,8.8,21,6.3,21z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "5.5,17 4.1,15.6 3.2,16.6 5.5,18.9 9.5,14.9 8.5,14  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferGoods);
export default __webpack_public_path__ + "static/media/TransferGoods.857f0751d6dcb31f47b44a7ac44f31d7.svg";
export { ForwardRef as ReactComponent };